import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, ShowVerticalScrollbar } from '../../../global/commonStyle';

interface Props {
  isEditMessage?: boolean;
}

const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  .ProseMirror {
    max-height: 208px;
    min-height: 120px;
    ${ShowVerticalScrollbar}
  }
  .ProseMirror-menubar {
    padding: var(--space-7);
    background: unset;
    border-bottom: 0.5px solid var(--border-primary);
  }

  .ProseMirror-icon {
    padding: var(--space-2) var(--space-6);
    border: 0 solid var(--border-primary);
    border-radius: var(--border-radius-4);
    svg {
      fill: var(--text-secondary);
    }
    &:hover {
      padding: var(--space-2) var(--space-6);
      background: var(--neutral-secondary);
      svg {
        fill: var(--text-primary);
      }
    }
  }
`;

const Content = styled.div<Props>`
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: var(--background-primary);
  box-shadow: var(--shadow-card);
  border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-16) var(--border-radius-16);
  gap: var(--space-24);
  .figma-animation {
    img {
      max-width: unset;
      max-height: unset;
    }
  }
  img {
    max-width: auto;
    max-height: auto;
  }
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;
const IconSection = styled.div<Props>`
  ${AlignCenter}
  flex-direction: ${({ isEditMessage }) => (isEditMessage ? 'row-reverse' : 'row')};
  justify-content: end;
  gap: var(--space-7);
  .active {
    svg {
      fill: var(--text-primary);
    }
  }
`;

const UploadDiv = styled.div`
  color: var(--text-primary);
`;

const FileBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-10);
  margin-bottom: var(--space-0);
`;

const BottomSection = styled.div`
  ${AlignCenter}
  justify-content: end;
  gap: var(--space-7);
`;

export { MainDiv, Content, FileBox, IconSection, UploadDiv, BottomSection };
